import Home from "../pages/Home";
import NotFound from "../pages/NotFound";
import Politica from '../pages/Politica';
import Ayuda from '../pages/Ayuda';
import Cancelar from '../pages/Cancelar';
import Terminos from '../pages/Terminos';
import QuejasyReclamos from '../pages/QuejasyReclamos';

interface IRoutes {
  path: string,
  element?: any,
}

const routes: IRoutes[] = [
  {
    path: '*',
    element: NotFound,
  },
  {
    path: '/',
    element: Home
  },
  {
    path: '/pdp',
    element: Politica
  },
  {
    path: '/ayuda',
    element: Ayuda
  },
  {
    path: '/cancelar',
    element: Cancelar
  },
  {
    path: '/arrepentimiento',
    element: QuejasyReclamos
  },
  {
    path: '/terminos',
    element: Terminos
  },
]

export default routes;
